/**
 * Persist one draft channel listing per selected connector.
 * A throw or a failed result is recorded for that connector and the next
 * connector is still attempted. This never publishes.
 */

export interface ChannelDraftSaveResult {
  success: boolean;
  error?: string | null;
}

export async function recordWizardChannelDrafts<T extends { displayName: string }>(
  selected: T[],
  createOne: (intent: T) => Promise<ChannelDraftSaveResult>,
): Promise<string[]> {
  const failures: string[] = [];
  for (const intent of selected) {
    try {
      const listing = await createOne(intent);
      if (!listing.success) {
        failures.push(`${intent.displayName}: ${listing.error ?? "draft listing was not saved"}`);
      }
    } catch (error) {
      const message = error instanceof Error && error.message
        ? error.message
        : "draft listing was not saved";
      failures.push(`${intent.displayName}: ${message}`);
    }
  }
  return failures;
}
